import { useTranslation } from 'react-i18next';

import type { InviteeDiscount } from '~/types/user';

import { LinkButton } from '~/components';
import { routes } from '~/providers/RouterProvider/router.routes';

import { inviteeDiscountCountdownStyle } from './TopBar.css';

type Props = {
  discount: InviteeDiscount | null;
};

export const InviteeDiscountCountdown = ({ discount }: Props) => {
  const { t } = useTranslation(['common']);

  if (discount?.type !== 'ShelterForFree') {
    return null;
  }

  return (
    <LinkButton className={inviteeDiscountCountdownStyle} emphasis="secondary" icon="Redeem" to={routes.pricing}>
      {t('common:topbar.activePremiumForFree', { count: discount.daysActive })}
    </LinkButton>
  );
};
